import { excludedColumnCodes } from "../EximConstants";
import { validateRecord } from "./RecordValidator";
import { INPUT_TYPE } from "deskera-ui-library";
import { FIELD, getFormattedTimeString, isEmpty, parseTimeIn24Hrs } from "./ImportUtility";
import { TENANT, TenantService } from "../../../managers/TenantManagerService";
import moment from "moment";
import { DATE_FORMAT } from "../../../constants/Constant";
import { DATE_FIELDS } from "./ImportFile";

const NON_EDITABLE_FIELDS = ["punchTime"];

function mapStringToDropdown(recordValue, existingOptions) {
  if (recordValue.trim()) {
    const importedOptions = recordValue.split(",");
    const mappedValues = [];
    importedOptions.forEach((importedOption) => {
      /* Skip if option string is empty */
      if (!importedOption.trim()) return;

      const matchFound = existingOptions.some((option) => {
        /* need exact match here */
        if (option.name.toLowerCase() === importedOption.toLowerCase()) {
          mappedValues.push(option.id);
          return true;
        }
      });

      /* TBD DropDown Validations - Requires changes in DataGrid for showcasing unmapped strings */
      /* if (!matchFound) {
        mappedValues.containsInvalid = true;
      } */
    });

    return mappedValues;
  }

  return [];
}

export function mapFileDataToSystem(
  importedHeaderMappings,
  fileData,
  tableColumns
) {
  return new Promise((onSuccess, onFailure) => {
    try {
      if (!importedHeaderMappings?.length || !fileData?.length) {
        onFailure("HeaderMappings or FileData is missing");
        return;
      }

      const invalidRows = [];
      const importedHeaderMap = new Map();
      importedHeaderMappings.forEach((headerProps) => {
        importedHeaderMap.set(headerProps.importedKey, headerProps);
      });

      const importRecords = fileData.map((row, rowIndex) => {
        /* for Each row pick up every property and return new row with mapped header */
        const newRow = {};
        Object.keys(row).forEach((property) => {
          const headerProps = importedHeaderMap.get(property);
          if (headerProps && !headerProps.isEscaped) {
            const key = headerProps.dkColKey;

            if (
              headerProps.type === INPUT_TYPE.SELECT ||
              headerProps.type === INPUT_TYPE.MULTI_SELECT
            ) {
              newRow[key] = mapStringToDropdown(
                row[property],
                headerProps.options
              );
            } else {
              newRow[key] = row[property];
            }
          }
        });

        newRow.recordIndex = rowIndex;
        newRow.invalidKeys = validateRecord(newRow, tableColumns);

        if (newRow.invalidKeys.length) {
          invalidRows.push(rowIndex);
        }

        return newRow;
      });

      onSuccess({
        importRecords,
        invalidRows,
      });
    } catch (err) {
      console.log(err)
      onFailure(
        "Something went wrong with importing file records with mapped headers"
      );
    }
  });
}

function mapStringToDropdown2(recordValue, existingOptions, defaultOption) {
    const mappedValues = [];

    if (!isEmpty(recordValue)) {
        const option = existingOptions.find((o) => o?.name?.toLowerCase()?.trim() === String(recordValue)?.toLowerCase()?.trim());
        if (option) {
            mappedValues.push(option.id);
        } else if(!isEmpty(defaultOption) && Array.isArray(defaultOption) && defaultOption.length > 0) {
            const defaultExistingOption = existingOptions?.find((o) => o?.name?.toLowerCase() === String(defaultOption[0]).toLowerCase());
            if(defaultExistingOption) {
              mappedValues.push(defaultExistingOption.id);
            }
        }
    }

    return mappedValues;
}

export function mapFileDataToSystem2(importedHeaderMappings, fileData, props) {
    return new Promise((onSuccess, onFailure) => {
        try {
            if (!importedHeaderMappings?.length || !fileData?.length) {
                onFailure("HeaderMappings or FileData is missing");
                return;
            }

            const invalidRows = [];
            const importedHeaderMap = new Map();
            importedHeaderMappings.forEach((headerProps) => {
                importedHeaderMap.set(headerProps.importedKey, headerProps);
            });

            const importRecords = fileData.map((row, rowIndex) => {
                /* for Each row pick up every property and return new row with mapped header */
                const newRow = {};
                Object.keys(row).forEach((property) => {
                    const headerProps = importedHeaderMap.get(property);
                    if (headerProps && !headerProps.isEscaped) {
                        const key = headerProps.dkColKey;
                        if (headerProps.type === INPUT_TYPE.SELECT || headerProps.type === INPUT_TYPE.MULTI_SELECT) {
                            const defaultOption = props?.tableColumns?.find(column=>String(column.fieldName)?.toLocaleLowerCase() === String(property)?.toLocaleLowerCase())
                            newRow[key] = mapStringToDropdown2(row[property], headerProps.options,defaultOption?.defaultValue);
                        } else if(headerProps.type === "dropdown") {
                          if (!isEmpty(row[property])) {
                              const option = headerProps.options.find((o) => o.name.toLowerCase() === String(row[property]).toLowerCase());
                              if (option) {
                                  newRow[key] = option.name;
                              }
                          }
                        } else {
                            newRow[key] = row[property];
                        }

                        switch (key) {
                            case FIELD.PUNCH_DATE:
                                if (!isEmpty(row[property])) {
                                    let date = moment(row[property], TenantService.get(TENANT.DATE_FORMAT));
                                    if (!date.isValid()) {
                                        date = moment(row[property], DATE_FORMAT.SLASH.MMDDYYYY);
                                    }

                                    newRow[key] = date
                                }
                                break;

                            case FIELD.PUNCH_TIME:
                                if (!isEmpty(row[property])) {
                                    const time = parseTimeIn24Hrs(row[property]);
                                    newRow[key] = getFormattedTimeString(time.hours, time.minutes);
                                }
                                break;
                        }
                    }
                });

                newRow.recordIndex = rowIndex;
                newRow.invalidKeys = validateRecord(newRow, props);

                if (newRow.invalidKeys.length) {
                    invalidRows.push(rowIndex);
                }

                return newRow;
            });

            onSuccess({ importRecords, invalidRows });
        } catch (err) {
            onFailure("Something went wrong with importing file records with mapped headers");
        }
    });
}

function stringComparator(str1, str2) {
  if (!str1 || !str2) {
    return false;
  }

  str1 = str1.trim().toLowerCase();
  str2 = str2.trim().toLowerCase();

  if (str1.length < str2.length) {
    const regex = new RegExp(str1);
    return regex.test(str2);
  } else {
    const regex = new RegExp(str2);
    return regex.test(str1);
  }
}

function generateMappings(importedDataRow, existingHeaders, headerMappings) {
  const unMappedHeaders = [];
  const mappedHeaderId = [];

  Object.keys(importedDataRow).forEach((importedKey) => {
    /* To exclude the status/segment columns from the imported columns */
    if (excludedColumnCodes.includes(importedKey.toLowerCase())) return;

    let matchFound = false;
    for (let index in existingHeaders) {
      const systemHeader = existingHeaders[index];

      matchFound = mappedHeaderId.indexOf(systemHeader.id) === -1 && stringComparator2(systemHeader.name, importedKey);

      if (matchFound && importedKey && importedKey.trim()) {
        headerMappings.push({
          rowId: `row-${importedKey}`,
          importedKey: importedKey,
          dkColKey: systemHeader.id,
          selectedOption: systemHeader.name,
          type: systemHeader.type,
          options: systemHeader.options,
          sampleData: importedDataRow[importedKey],
          required: systemHeader.required,
          isValid: true,
        });

        mappedHeaderId.push(systemHeader.id);

        break;
      }
    }

    if (!matchFound) {
      unMappedHeaders.push({
        rowId: `row-${importedKey}`,
        importedKey,
        dkColKey: 0,
        selectedOption: "Assign Field",
        type: "Text",
        options: null,
        sampleData: importedDataRow[importedKey],
        required: false,
        isValid: false,
      });
    }
  });

  /* For keeping all the unmapped headers last in order */
  headerMappings.push(...unMappedHeaders);
}

function stringComparator2(str1, str2) {
    if (!str1 || !str2) {
        return false;
    }

    return str1.trim().toLowerCase() === str2.trim().toLowerCase();
}

function generateMappings2(importedDataRow, deskeraHeaders, headerMappings) {
    const mappedHeaderId = [];
    const importedKeys = Object.keys(importedDataRow);

    deskeraHeaders.forEach((systemHeader) => {
        /* To exclude the status/segment columns from the imported columns */
        if (excludedColumnCodes.includes(systemHeader.fieldName.toLowerCase())) return;

        const index = importedKeys.findIndex((key) => {
            return mappedHeaderId.indexOf(systemHeader.id) === -1 && stringComparator2(systemHeader.name, key);
        });

        let mapping;
        if (index !== -1) {
            const key = importedKeys[index];
            if (key && key.trim()) {
                mapping = {
                    rowId: `row-${systemHeader.id}`,
                    dkColKey: systemHeader.key,
                    dkColName: systemHeader.displayName,
                    importedKey: key,
                    selectedOption: key,
                    type: systemHeader.type,
                    options: systemHeader.options,
                    sampleData: importedDataRow[key] ? importedDataRow[key] : "-",
                    required: systemHeader.required,
                    isValid: true,
                };

                systemHeader.colHeader = systemHeader.displayName;
                if (isEmpty(systemHeader.editable)) {
                    systemHeader.editable = !NON_EDITABLE_FIELDS.includes(systemHeader.fieldName);
                }

                if (DATE_FIELDS.includes(key) && importedDataRow[key]) {
                  const date = Date.parse(importedDataRow[key]);
                  mapping.sampleData = !isNaN(date) ? moment(date).format(TenantService.get(TENANT.DATE_FORMAT)) : mapping.sampleData;
                }
            }
        } else {
            mapping = {
                rowId: `row-${systemHeader.id}`,
                dkColKey: systemHeader.key,
                dkColName: systemHeader.displayName,
                importedKey: null,
                selectedOption: "Assign Field",
                type: systemHeader.type,
                options: systemHeader.options,
                sampleData: "-",
                required: systemHeader.required,
                isValid: false,
            }
        }

        if (mapping) {
          if (systemHeader.customFieldConfig) {
            mapping.rowId = `cf-row-${systemHeader.id}`;
          }
  
          headerMappings.push(mapping);
          mappedHeaderId.push(systemHeader.id);
        }
    });
}

/* This utility maps data headers obtained from users to the existing headers present in system. */
export function dataMapper(importedData, existingHeaders, isNewFlow) {
  const headerMappings = [];
  if (isNewFlow) {
      generateMappings2(importedData, existingHeaders, headerMappings);
  } else {
      generateMappings(importedData, existingHeaders, headerMappings);
  }

  return headerMappings;
}

/* For Bulk Records Upload API
 - Removes the blank cells
*/
export function generateImportRecordsPayload(records) {
  return records.map((record) => {
    const newRecord = {};
    Object.keys(record).forEach((key) => {
      const value = record[key];
      if (Array.isArray(value)) {
        if (value.length) {
          newRecord[key] = value;
        }
      } else if (value) {
        newRecord[key] = value;
      }
    });

    return { cells: newRecord };
  });
}

function optionsToString(selectedIds, options) {
  if (!selectedIds?.length) return "";

  const res = selectedIds.reduce((cellValue, selectedId) => {
    const selectedOption = options.filter(
      (option) => option.id === selectedId
    )[0];
    return `${cellValue}${selectedOption.name},`;
  }, "");

  return res.slice(0, -1);
}

/* Need to convert the deskera column headers to the original File Headers 
which user uploaded initially for Import Logs
*/
export function modifyRecordForUpload({ importRecords, mappedHeaders }) {
  return importRecords.map((record) => {
    const newRow = {};
    mappedHeaders.forEach((header) => {
      if (
        header.type === INPUT_TYPE.SELECT ||
        header.type === INPUT_TYPE.MULTI_SELECT
      ) {
        newRow[header.importedKey] = optionsToString(
          record[header.dkColKey],
          header.options
        );
      } else if (header.dkColKey !== "0") {
        newRow[header.importedKey] = record[header.dkColKey];
      }
    });

    return newRow;
  });
}
